// Small math helpers shared by client (prediction/interpolation) and server.
export const clamp = (x, min, max) => x < min ? min : x > max ? max : x;
export const lerp = (a, b, t) => a + (b - a) * t;
/** Move `current` toward `target` by at most `maxDelta`, never overshooting.
 * Used for framerate-independent linear ramps (e.g. tank speed toward its
 * input-driven target, at a fixed acceleration in units/sec — pass
 * `accel * dt` as maxDelta). Symmetric client/server use is required for
 * this to stay deterministic-replay-safe (see LocalTankController/Tank). */
export const moveToward = (current, target, maxDelta) => {
    const diff = target - current;
    if (Math.abs(diff) <= maxDelta)
        return target;
    return current + Math.sign(diff) * maxDelta;
};
/** Shortest signed angular difference (b - a) wrapped to [-π, π]. */
export const angleDiff = (a, b) => {
    let d = (b - a) % (Math.PI * 2);
    if (d < -Math.PI)
        d += Math.PI * 2;
    if (d > Math.PI)
        d -= Math.PI * 2;
    return d;
};
/** Interpolate from angle a toward b along the shortest arc by t (0..1). */
export const angleLerp = (a, b, t) => a + angleDiff(a, b) * t;
/** Wrap any angle to [-π, π]. */
export const wrapAngle = (a) => angleDiff(0, a);
//# sourceMappingURL=math.js.map